import React from "react";

import BarChart from "components/pages/dashboard/chart/BarChart";
import useBillableIntervalChart from "./useBillableIntervalChart";

const BIllableIntervalChart = ({ data }) => {
  const { options, chartData } = useBillableIntervalChart(data);

  return (
    <BarChart
      options={options}
      data={chartData}
      height={300}
      style={{ cursor: "pointer" }}
    />
  );
};

export default BIllableIntervalChart;
